<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
            <img class="img" :src="item.kv" alt="" />
            <div class="text-area base-container">
              <div class="text-ct  wow fadeInLeft" data-wow-delay=".4s">
                <div class="text-block">
                  <div class="tit">{{ item.title }}</div>
                  <div class="sectit">{{ item.intro }}</div>
                  <div class="more"><a :href="item.link" target="_blank">了解更多</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="homepage-swiper-pagination swiper-pagination"></div>
      </div>
    </div>

    <div id="article" class="container-fuild">
      <div class="article-ct base-container">
        <div class="article-list">
          <div class="article-item wow fadeIn" data-wow-delay=".4s" v-for="(item, index) in articleList" :key="index">
            <div class="img"><img :src="item.pic" /></div>
            <div class="tit">{{ item.title }}</div>
            <div class="text">{{ item.intro }}</div>
            <div class="more">
              <div class="more-btn" @click="articleMore(item.link)">
                <div class="btn-text">了解更多</div>
                <img src="@/assets/img/icon_jiantou.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="about" class="container-fuild wow fadeIn" data-wow-delay=".4s">
      <div class="about-ct base-container">
        <div class="about-img"><img src="@/assets/img/index_about_pic_1.png" /></div>
        <div class="about-info">
          <div class="tit">关于<span>Peet’s</span></div>
          <div class="text"><span>Peet’s Coffee</span>创始人阿尔弗雷德·皮特（<span>Alfred
              Peet</span>）上世纪60年代移民到美国，因对遍地乏味苦涩的咖啡深恶痛绝，在西海岸掀起了一场咖啡革命，他发明独特的深烘手法，坚持手工制作与新鲜烘焙咖啡，在加州伯克利开设第一家<span>Peet’s</span>营业至今，以高品质好咖啡闻名于世，被称作“咖啡界的祖师爷”
            。 </div>
          <div class="more" @click="goMore">了解更多</div>
        </div>
      </div>
    </div>

    <div id="contact" class="container-fuild wow fadeIn" data-wow-delay=".4s">
      <div class="contact-ct base-container">
        <div class="contact-img"><img src="@/assets/img/index_contact_pic_1.jpg" /></div>
        <div class="contact-info">
          <div class="tit">联系我们</div>
          <div class="text">请您进入微信小程序，点击我的页面，<br />点击客服头像即可留下您的问题</div>
          <div class="info-bottom">
            <div class="info-l">您好，<span>Peet's Coffee</span>的客服人工<br />在线回复时间为周一至周五<span>9:00~18:00</span></div>
            <div class="info-r">
              <div class="wechatmini"><img src="@/assets/img/miniscan-1.jpg" /></div>
              <div class="wechattext">微信小程序</div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import AMapLoader from '@amap/amap-jsapi-loader';
import { mapState } from "vuex";

export default {
  name: "HomePage",
  data() {
    return {
      show: true,
      bannerSwiper: '',
      swiperList: [],
      articleList: []
    };
  },
  mounted() {
    let that = this;
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true,
      effect: "slide",
      pagination: {
        el: ".homepage-swiper-pagination",
        clickable: true,
      },
      observer: true,
      observeParents: true
    });

    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    that.getBanner();
    that.getArticle();
  },
  methods: {

    async getBanner() {
      const { data: res } = await this.$http.get("/index/kv");
      if (res.code !== 200) {
        return this.$message.error("获取失败！");
      }
      //console.log("消息===", res);
      this.swiperList = res.data;
    },

    async getArticle() {
      const { data: res } = await this.$http.get("/index/news");
      if (res.code !== 200) {
        return this.$message.error("获取失败！");
      }
      //console.log("消息===", res);
      this.articleList = res.data;
    },

    articleMore(url) {
      let _url = url.includes('https://');
      if (_url) {
        window.open(url, '_blank');
      } else {
        this.$router.push("/news/newsdetail");
      }
    },

    goMore() {
      this.$router.push('/brand');
    },

    handler(val) {
      console.log(val)
      var mo = function (e) {
        e.preventDefault();
      }
      if (val) {
        document.body.style.overflow = 'hidden';
        document.getElementById("htmlbase").style.overflow = 'hidden';
        document.addEventListener('touchmove', mo, false);
      } else {
        document.body.style.overflow = '';
        document.getElementById("htmlbase").style.overflow = '';
        document.addEventListener('touchmove', mo, false);
      }
    },

  },
};
</script>
<style lang="scss">
.banner-swiper {

  &.swiper-container-horizontal>.swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 55px;
  }

  .swiper-pagination-bullet {
    width: 48px;
    height: 6px;
    display: inline-block;
    border-radius: 0;
    background: #f3e9dc;
    opacity: 0.3;
  }

  .swiper-pagination-bullet-active {
    background: #f3e9dc;
    opacity: 1;
  }
}


.i-search-option {
  .el-select-dropdown__item {
    font-family: SourceHanSansCN-Regular;
  }
}


.customreviews-swiper {

  &.swiper-container-horizontal>.swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 0;
  }

  .swiper-pagination-bullet {
    width: 50px;
    height: 2px;
    display: inline-block;
    border-radius: 0;
    background: #D8D8D8;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #607BCA;
  }
}
</style>
<style lang="scss" scoped>
/* 整体盒子 */
body::-webkit-scrollbar {
  width: 0 !important;
}

#HomePage {
  width: 100%;
  position: relative;

  .base-container {
    max-width: 1440px;
    margin: 0 auto;
  }

  #swiper {
    height: calc(100vh - 90px);

    .banner-swiper {
      width: 100%;
      height: 100%;

      .swiper-slide {
        position: relative;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .img-bg {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.3);
        }
      }

      .text-area {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        z-index: 10;
        color: #fff;

        .text-ct {
          width: 542px;
          height: 642px;
          box-sizing: border-box;
          padding: 0 64px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;

          .tit {
            font-family: "siyuanNormal";
            font-size: 36px;
            line-height: 72px;
            color: #8e713c;
            margin-bottom: 42px;
          }

          .sectit {
            font-size: 14px;
            color: #000;
          }

          .more {
            width: 164px;
            height: 66px;
            line-height: 66px;
            text-align: center;
            color: #fff;
            font-family: $SB;
            font-weight: bold;
            font-size: 24px;
            background: #8e713c;
            margin-top: 86px;
            cursor: pointer;

            a {
              color: #fff;
              text-decoration: none;
            }
          }
        }

      }
    }
  }

  #article {
    width: 100%;
    padding: 180px 0;
    position: relative;

    .article-ct {
      .article-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .article-item {
          width: 684px;
          margin-bottom: 55px;

          .img {
            width: 684px;
            height: 322px;
            overflow: hidden;
            margin-bottom: 30px;

            &:hover {
              img {
                transform: scale(1.1);
              }
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: all .6s;
            }
          }

          .tit {
            font-family: $SB;
            font-size: 24px;
            line-height: 32px;
            font-weight: bold;
            color: #8e713c;
            margin-bottom: 29px;
          }

          .text {
            height: 40px;
            overflow: hidden;
            font-size: 14px;
            color: #1c1c1c;
          }

          .more {
            margin-top: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .more-btn {
              padding: 10px 15px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #8e713c;
              color: #fff;
              cursor: pointer;

              .btn-text {
                font-size: 14px;
                font-family: $SB;
                font-weight: bold;
                margin-right: 10px;
              }

              img {
                width: 17px;
              }
            }
          }
        }
      }
    }
  }

  #about {
    width: 100%;
    position: relative;

    .about-ct {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .about-img {
        width: 784px;
        height: auto;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .about-info {
        width: calc(50% - 125px);
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;

        .tit {
          font-size: 36px;
          font-family: $SB;
          font-weight: bold;
          color: #8e713c;
          margin-bottom: 60px;

          span {
            font-family: $GoB;
          }
        }

        .text {
          font-size: 14px;
          line-height: 24px;
          color: #1c1c1c;
          letter-spacing: 1px;

          span {
            font-family: $GoB;
          }
        }

        .more {
          width: 164px;
          height: 66px;
          line-height: 66px;
          background: #8e713c;
          text-align: center;
          color: #fff;
          font-size: 24px;
          font-family: $SB;
          font-weight: bold;
          margin-top: 40px;
          cursor: pointer;
        }
      }
    }
  }

  #contact {
    width: 100%;
    height: 541px;
    position: relative;
    z-index: 101;

    .contact-ct {
      width: 100%;
      background: #f7f6f1;
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
      margin-top: 164px;

      .contact-img {
        width: 796px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .contact-info {
        width: calc(100% - 796px);
        box-sizing: border-box;
        padding-left: 65px;
        padding-right: 78px;
        color: #8e713c;

        .tit {
          font-size: 36px;
          line-height: 72px;
          font-family: $SB;
          font-weight: bold;
          margin-bottom: 12px;
        }

        .text {
          font-size: 14px;
          margin-bottom: 25px;

          span {
            font-family: $GoB;
          }
        }

        .info-bottom {
          display: flex;
          align-items: flex-start;
          border-top: 1px solid #8e713c;
          padding-top: 32px;
          justify-content: space-between;
          font-size: 14px;

          .info-l {
            font-size: 14px;

            span {
              font-family: $GoB;
            }
          }

          .info-r {
            text-align: center;
            font-size: 14px;

            .wechatmini {
              width: 120px;
              height: 120px;
              background: #fff;
              margin-bottom: 10px;

              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

}

@media screen and (min-width: 1200px) {
  #HomePage {}
}

@media screen and (min-width: 1439px) {
  #HomePage {}
}

@media screen and (min-width: 768px) and (max-width: 996px) {
  #HomePage {
    .base-container {
      padding: 0 15px;
    }

    #swiper {
      .banner-swiper {
        .text-area {
          padding-left: 15px;
        }
      }
    }


  }
}

@media screen and (min-width: 997px) and (max-width: 1199px) {
  #HomePage {
    .base-container {
      padding: 0 15px;
    }

    #swiper {
      .banner-swiper {
        .text-area {
          padding-left: 15px;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue